module.exports = __webpack_public_path__ + "assets/keypad-sounds/beep4-9ea9918b8ebd6244007c72361d48c323.wav";